"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractPolygon = extractPolygon;
const Util_1 = require("../../Util");
const v6Common_1 = require("./v6Common");
function extractPolygon(isModule, node, ensureCompleted = false) {
    const points = [];
    let strokeWidth = 1;
    let fillType = isModule ? 'solid' : 'none';
    let style;
    let layerName;
    const flipY = isModule ? -1 : 1;
    node.nodes.forEach((n) => {
        switch (n.name) {
            case 'pts': {
                n.nodes.forEach((n2) => {
                    switch (n2.name) {
                        case 'xy': {
                            points.push([parseFloat(n2.values[0]), flipY * parseFloat(n2.values[1])]);
                            break;
                        }
                    }
                });
                break;
            }
            case 'stroke': {
                n.nodes.forEach((n2) => {
                    switch (n2.name) {
                        case 'width': {
                            strokeWidth = parseFloat(n2.values[0]);
                            break;
                        }
                        case 'type': {
                            style = (0, v6Common_1.parseKicadLineType)(n2.values[0]) || (isModule ? undefined : 'dash');
                            break;
                        }
                    }
                });
                break;
            }
            case 'fill': {
                n.nodes.forEach((n2) => {
                    switch (n2.name) {
                        case 'type': {
                            fillType = n2.values[0];
                            break;
                        }
                    }
                });
                if (n.values.length > 0) {
                    fillType = n.values[0];
                }
                break;
            }
            case 'layer': {
                layerName = (0, Util_1.removeQuotes)(n.values[0]);
                break;
            }
            case 'width': {
                strokeWidth = parseFloat(n.values[0]);
                break;
            }
            case 'type': {
                style = (0, v6Common_1.parseKicadLineType)(n.values[0]) || (isModule ? undefined : 'dash');
                break;
            }
        }
    });
    if (ensureCompleted && points.length >= 2) {
        const lastPoint = points[points.length - 1];
        if (points[0][0] !== lastPoint[0] || points[0][1] !== lastPoint[1]) {
            points.push([points[0][0], points[0][1]]);
        }
    }
    return { points, strokeWidth, style, fillType, layerName };
}
//# sourceMappingURL=v6ExtractPolygon.js.map